import { invoke } from '@shared/easyfy.decorators';
import { globalEvent } from '@shared/easyfy.core';

@invoke
export class SocialMediaShare {
  onInit() {
    globalEvent({
      type: 'click',
      events: [
        {
          action: 'copy-link',
          callback: this.copyLinkToClipboard,
        },
        {
          action: 'share-to',
          callback: this.shareLink,
        },
        {
          event: 'close-dialog',
          callback: this.closeDialog,
        },
      ],
    });
  }
  private shareLink = (e: Event) => {
    const element = e?.target as HTMLElement;
    const media = element?.dataset?.media;

    const currentUrl = window.location.href;
    let mediaLink = '';
    switch (media) {
      case 'facebook':
        mediaLink = `https://www.facebook.com/sharer/sharer.php?u=${currentUrl}`;
        break;
      case 'linkedin':
        mediaLink = `https://www.linkedin.com/shareArticle?mini=true&url=${currentUrl}&source=LinkedIn`;
        break;
      case 'x':
        mediaLink = `https://twitter.com/intent/tweet?url=${currentUrl}`;
        break;
      default:
        break;
    }
    if (mediaLink) {
      window.open(mediaLink, '_blank');
    }
  };

  private copyLinkToClipboard = () => {
    const currentUrl = window.location.href;
    this.copyContent(currentUrl);
  };

  private copyContent = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      const dialog = document.getElementById('copied-to-clipboard-dialog') as HTMLDialogElement;

      dialog?.show();

      setTimeout(() => {
        dialog?.close();
      }, 2900);
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  };

  private closeDialog = (e: Event) => {
    const element = e.target as HTMLElement;
    const dialog = element.closest('#copied-to-clipboard-dialog') as HTMLDialogElement;
    dialog?.removeAttribute('open');
  };
}
